import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createStore } from 'vuex'

// Create a new store instance.
const store = createStore({
  state () {
    return {
      aufbauDnD_done: false,
      aufbauMC_done: false,
      aufbauMC2_done: false,
      aufbauMC3_done: false,
      aufbauMC4_done: false,
      aufbauForm2_done: false,
      aufbauDnD2_done: false,
      aufbauMC5_done: false,
      aufbauMC6_done: false,
      aufbauMC7_done: false,
      aufbauForm3_done: false,
      aufbauDnD3_done: false,
      aufbauMC8_done: false,
      aufbauMC9_done: false,
      aufbauMC10_done: false,
      aufbauForm4_done: false,
      aufbauForm_done: false,

      audioDnD2_done: false,
      audioDnD3_done: false,
      audioMC_done: false,
      audioMC5_done: false,
      audioMC2_done: false,
      audioForm3_done: false,
      audioMC4_done: false,
      audioMC9_done: false,
      audioForm4_done: false,
      audioForm5_done: false,
      audioForm_done: false,
      audioMC6_done: false,
      audioForm2_done: false,
      audioForm6_done: false,
      audioMC7_done: false,
      audioDnD_done: false,
      audioForm7_done: false,
      audioForm8_done: false,
      // offene Klausuraufgabe
      audioKL_done: false,
      audioKL2_done: false,
      audioForm10_done: false,
      audioForm11_done: false,
      audioForm9_done: false,
      audioMC8_done: false,







      task1done: false,
    }
  },
  mutations: {
    // use like this: this.$store.commit('setTaskCompletionState', {varname: <nameofthisvariable>, state: <newstateofthisvariable>})
    setTaskCompletionState (state, payload) {
      state[payload.varname] = payload.state
    }
  }
})

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
//import "@fortawesome/fontawesome-free";
//import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
//import { Vue } from "vue";
//import { BootstrapVueIcons } from "bootstrap-vue";
//import "bootstrap-vue/dist/bootstrap-vue-icons.min.css";
library.add(fas);
//Vue.use(BootstrapVueIcons);

createApp(App).component('fa', FontAwesomeIcon).use(router).use(store).mount("#app");






